<template>
  <div class="seller-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Lista de {{ termPlural }}</span>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="d-flex align-items-center justify-content-end" >
              <b-col cols="auto">
                <b-form-input type="text" placeholder="Nome" v-model="searchBy"></b-form-input>
              </b-col>
              <b-col cols="auto">
                <router-link v-if="canAdd" tag="a" class="btn btn-primary btn-sm mr-2" :to="'/'+url+'/'+newTerm"><i class="far fa-dot-circle"></i> Cadastrar {{ termSingular }}</router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Lista de {{ termPlural }}</p>
                  <p class="title"><small>{{ pagination.total }} {{ termPlural }} cadastrad{{ letter }}s</small></p>
                </div>
              </div>
              <div class="content">

                <div v-if="pagination.lastPage > 1">
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getPeople"></b-pagination>
                  <hr>
                </div>

                <table class="table table-responsive w-100 d-block d-md-table">
                  <thead>
                    <tr>
                      <th>Nome da conta</th>
                      <th>Número</th>
                      <th>Conectada</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="line-add" v-if="canAdd">
                      <td colspan="4" class="text-center">
                        <router-link tag="a" class="btn btn-block btn-sm btn-add-new" :to="'/'+url+'/'+newTerm"><i class="far fa-plus-circle"></i> Adicionar nov{{ letter}} {{termSingular}}</router-link>
                      </td>
                    </tr>
                    <router-link tag="tr" :to="'/'+url+'/'+whatsapp.id" v-for="whatsapp in whatsapps" :key="whatsapp.id">
                      <td>{{ whatsapp.name }}</td>
                      <td>{{ whatsapp.number }}</td>
                      <td>{{ whatsapp.enabled ? 'Sim' : 'Não' }}</td>
                    </router-link>
                  </tbody>
                </table>
                <p v-if="searchBy == '' && whatsapps.length == 0" class="text-center sub-title">Você ainda não possui nenhum{{ (letter != 'o')?letter:'' }} {{ termSingular }} cadastrad{{ letter }}.</p>
                <p v-if="searchBy != '' && whatsapps.length == 0" class="text-center sub-title">A sua busca por {{ termSingular }} com o termo "{{ searchBy }}" não encontrou nenhum resultado.</p>

                <div v-if="pagination.lastPage > 1">
                  <hr>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getWhatsapps"></b-pagination>
                </div>

              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        termSingular: 'conta de Whatsapp',
        termPlural: 'contas de Whatsapp',
        url: 'contas-de-whatsapp',
        letter: 'a',
        newTerm: 'cadastrar-conta-de-whatsapp',
        module: 'sellers',

        pagination: {
          currentPage: 1,
          lastPage: 1,
          perPage: 20,
          total: 0
        },

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,

        whatsapps: [],

        searchBy: ''
      }
    },
    mounted () {
      this.eventBus.$emit('IS_LOADING', true);

      this.canSee = true;
      this.canAdd = true;
      this.canEdit = true;
      this.canRemove = true;

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.eventBus.$emit('IS_LOADING', false);
        this.$router.push({ path: '/' });
      } else {
        this.getWhatsapps(this.pagination.currentPage);
      }
    },
    watch: {
      searchBy: function() {
        this.getWhatsapps(1);
      }
    },
    methods: {
      getWhatsapps(page) {
        this.api.getWhatsapps({name: this.searchBy, page: page}).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.whatsapps = res.data.data;

          this.pagination.currentPage = res.data.current_page;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;


          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Whatsapps', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar as contas de whatsapp da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Whatsapps', err.response);
        });
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .seller-list {
    padding: 20px 0;

    .box-cj {
      .content {
        th {
          font-size: 14px;
          color: $cadetGray;
          border-top: 0;
        }

        tbody {
          font-size: 16px;
          color: $waikawaGray;

          .line-add {
            padding: 10px 0;
          }

          tr:nth-child(even) {
            background-color: $whisper;
          }

          tr:nth-child(odd) {
          }

          .seller-status {
            .status-indicator {
              font-size: 14px;

              &.enabled {
                color: $ufoGreen;
              }
              &.pending {
                color: $yellowSea;
              }
              &.incomplete {
                color: $valencia;
              }
              &.deleted {
                color: $dullRed;
              }
              &.disabled {
                color: #333333;
              }
            }
          }
        }
      }
    }
  }
</style>
